import { render } from "./NotificationsView.vue?vue&type=template&id=0de73192&scoped=true&lang=pug"
import script from "./NotificationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsView.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsView.vue?vue&type=style&index=0&id=0de73192&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de73192"]])

export default __exports__